import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue'),
    children: [
      {
        path: 'brief',
        component: () => import('../components/about-us/Brief.vue'),
      },
      {
        path: 'team',
        component: () => import('../components/about-us/Team.vue'),
      },
      {
        path: 'brands',
        component: () => import('../components/about-us/Brands.vue'),
        children:[
          {
            path: '',
            component: () => import('../components/about-us/brands/Entries.vue'),
          },
          {
            path: '1',
            component: () => import('../components/about-us/brands/LittleCastle.vue'),
          },
          {
            path: '2',
            component: () => import('../components/about-us/brands/InternationalMusical.vue'),
          },
          {
            path: '3',
            component: () => import('../components/about-us/brands/IndependentMusicLabel.vue'),
          },
          {
            path: '4',
            component: () => import('../components/about-us/brands/StagePerformingArt.vue'),
          },
          {
            path: '5',
            component: () => import('../components/about-us/brands/LiveMusicConcertBrand.vue'),
          },
          {
            path: '6',
            component: () => import('../components/about-us/brands/PerformanceTourismAndArt.vue'),
          },
          {
            path: '8',
            component: () => import('../components/about-us/brands/TheaterManagement.vue'),
          },
          {
            path: '9',
            component: () => import('../components/about-us/brands/OnlineTicketSales.vue'),
          },
          {
            path: '11',
            component: () => import('../components/about-us/brands/CulturalAndCreativeVentureCapitalFunding.vue'),
          }
        ]
      },
      {
        path: 'path',
        component: () => import('../components/about-us/Path.vue'),
      },
    ]
  },
  {
    path: '/productions',
    name:'Productions',
    component: () => import('../views/Productions.vue')
  },
  {
    path: '/theatres',
    name:'Theatres',
    component: () => import('../views/Theatres.vue')
  },
  {
    path: '/contact-us',
    name:'ContactUs',
    component: () => import('../views/ContactUs.vue')
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if(to.path.indexOf('/about-us/brands')===0&&from.path.indexOf('/about-us/brands')===0){
      return 
    }
    return savedPosition || {x:0,y:0}
  },
  routes
})

export default router
